export const ANALYTICS_ACTIONS = {
	FETCH_DASHBOARD_START:   'FETCH_DASHBOARD_START',
	FETCH_DASHBOARD_SUCCESS: 'FETCH_DASHBOARD_SUCCESS',
	FETCH_DASHBOARD_ERROR:   'FETCH_DASHBOARD_ERROR',
	FETCH_FILTERED_START:    'FETCH_FILTERED_START',
	FETCH_FILTERED_SUCCESS:  'FETCH_FILTERED_SUCCESS',
	FETCH_FILTERED_ERROR:    'FETCH_FILTERED_ERROR',
	FETCH_HOURLY_START:      'FETCH_HOURLY_START',
	FETCH_HOURLY_SUCCESS:    'FETCH_HOURLY_SUCCESS',
	FETCH_HOURLY_ERROR:      'FETCH_HOURLY_ERROR',
	FETCH_ROLES_SUCCESS:     'FETCH_ROLES_SUCCESS',
	FETCH_PROJECTS_SUCCESS:  'FETCH_PROJECTS_SUCCESS',
	SET_DAYS_FILTER:         'SET_DAYS_FILTER',
	SET_TOP_N:               'SET_TOP_N',
	SET_MODULE_FILTER:       'SET_MODULE_FILTER',
	SET_USER_FILTER:         'SET_USER_FILTER',
	SET_ROLE_FILTER:         'SET_ROLE_FILTER',
	SET_PROJECT_FILTER:      'SET_PROJECT_FILTER',
	SET_DATE_FILTER:         'SET_DATE_FILTER',
	CLEAR_FILTER:            'CLEAR_FILTER',
	CLEAR_DRILL_DOWN:        'CLEAR_DRILL_DOWN',
	CLEAR_DATE_FILTER:       'CLEAR_DATE_FILTER',
	TRACK_ACCESS_SUCCESS:    'TRACK_ACCESS_SUCCESS',
};

export const fetchDashboardStart   = ()        => ({ type: ANALYTICS_ACTIONS.FETCH_DASHBOARD_START });
export const fetchDashboardSuccess = (payload) => ({ type: ANALYTICS_ACTIONS.FETCH_DASHBOARD_SUCCESS, payload });
export const fetchDashboardError   = (error)   => ({ type: ANALYTICS_ACTIONS.FETCH_DASHBOARD_ERROR, error });

export const fetchFilteredStart    = ()        => ({ type: ANALYTICS_ACTIONS.FETCH_FILTERED_START });
export const fetchFilteredSuccess  = (payload) => ({ type: ANALYTICS_ACTIONS.FETCH_FILTERED_SUCCESS, payload });
export const fetchFilteredError    = (error)   => ({ type: ANALYTICS_ACTIONS.FETCH_FILTERED_ERROR, error });

export const fetchHourlyStart      = ()        => ({ type: ANALYTICS_ACTIONS.FETCH_HOURLY_START });
export const fetchHourlySuccess    = (payload) => ({ type: ANALYTICS_ACTIONS.FETCH_HOURLY_SUCCESS, payload });
export const fetchHourlyError      = (error)   => ({ type: ANALYTICS_ACTIONS.FETCH_HOURLY_ERROR, error });

export const fetchRolesSuccess     = (roles)    => ({ type: ANALYTICS_ACTIONS.FETCH_ROLES_SUCCESS,    roles });
export const fetchProjectsSuccess  = (projects) => ({ type: ANALYTICS_ACTIONS.FETCH_PROJECTS_SUCCESS, projects });

export const setDaysFilter         = (days)        => ({ type: ANALYTICS_ACTIONS.SET_DAYS_FILTER,    days });
export const setTopN               = (topN)        => ({ type: ANALYTICS_ACTIONS.SET_TOP_N,          topN });
export const setModuleFilter       = (module)      => ({ type: ANALYTICS_ACTIONS.SET_MODULE_FILTER,  module });
export const setUserFilter         = (user)        => ({ type: ANALYTICS_ACTIONS.SET_USER_FILTER,    user });
export const setRoleFilter         = (role)        => ({ type: ANALYTICS_ACTIONS.SET_ROLE_FILTER,    role });
export const setProjectFilter      = (project)     => ({ type: ANALYTICS_ACTIONS.SET_PROJECT_FILTER, project });
export const setDateFilter         = (date)        => ({ type: ANALYTICS_ACTIONS.SET_DATE_FILTER,    date });
export const clearFilter           = ()            => ({ type: ANALYTICS_ACTIONS.CLEAR_FILTER });
export const clearDrillDown        = ()            => ({ type: ANALYTICS_ACTIONS.CLEAR_DRILL_DOWN });
export const clearDateFilter       = ()            => ({ type: ANALYTICS_ACTIONS.CLEAR_DATE_FILTER });
export const trackAccessSuccess    = (entry)       => ({ type: ANALYTICS_ACTIONS.TRACK_ACCESS_SUCCESS, entry });